export * from './domain';
export * from './dto';
export * from './builders';
export * from './testkit';
export * from './my-statistics';
export var calcRate = function (value, total) {
    return total && total > 0 ? Number(((100 / total) * value).toFixed(2)) : 0;
};
export var createHistogramCallsPoint = function (item) { return ({
    x: item.x,
    y: calcRate(item.y, item.totalCalls),
    totalCalls: item.y || 0
}); };
export var createHistogramAssistedChatPoint = function (item) { return ({
    x: item.x,
    y: calcRate(item.y, item.totalChats),
    totalChats: item.y || 0
}); };
export var createCallsTermData = function (item) { return ({
    term: item.term,
    value: calcRate(Number(item.value), item.totalCalls),
    totalCalls: item.value || 0
}); };
export var createTeamPerformanceInsightsApi = function (baseUrl, http) {
    var url = baseUrl + "/analytics/team";
    return {
        getOverview: function (dto) { return http.post(url + "/overview", dto); },
        getMyOverview: function (dto) { return http.post(url + "/me", dto); },
        getNumberOfRepliesCumulative: function (dto) { return http.post(url + "/agentReplies/cumulative", dto); },
        getNumberOfRepliesHistogram: function (dto) { return http.post(url + "/agentReplies/histogram", dto); },
        getSolvedTicketsCumulative: function (dto) { return http.post(url + "/solvedTickets/cumulative", dto); },
        getSolvedTicketsHistogram: function (dto) { return http.post(url + "/solvedTickets/histogram", dto); },
        getCallVolumeCumulative: function (dto) { return http.post(url + "/callVolume/cumulative", dto); },
        getCallVolumeHistogram: function (dto) { return http.post(url + "/callVolume/histogram", dto); },
        getHandleTimeCumulative: function (dto) { return http.post(url + "/handleTime/cumulative", dto); },
        getHandleTimeHistogram: function (dto) { return http.post(url + "/handleTime/histogram", dto); },
        getAssistedCallsCumulative: function (dto) { return http.post(url + "/assistedCalls/cumulative", dto)
            .then(function (data) { return ({
            value: data.value.map(createCallsTermData),
            compared: data.compared && data.compared.map(createCallsTermData)
        }); }); },
        getAssistedCallsHistogram: function (dto) { return http.post(url + "/assistedCalls/histogram", dto)
            .then(function (data) {
            var value = Object.keys(data.value).reduce(function (acc, key) {
                acc[key] = data.value[key].map(createHistogramCallsPoint);
                return acc;
            }, {});
            var compared = data.compared && Object.keys(data.compared)
                .reduce(function (acc, key) {
                acc[key] = data.compared[key].map(createHistogramCallsPoint);
                return acc;
            }, {});
            return { value: value, compared: compared };
        }); },
        getNewPublishedArticlesCumulative: function (dto) {
            return http.post(url + "/publishedArticles/cumulative", dto);
        },
        getNewPublishedArticlesHistogram: function (dto) { return http.post(url + "/publishedArticles/histogram", dto); },
        getArticleUpdatesCumulative: function (dto) { return http.post(url + "/updatedArticles/cumulative", dto); },
        getArticleUpdatesHistogram: function (dto) { return http.post(url + "/updatedArticles/histogram", dto); },
        getAgentsTable: function (dto) { return http.post(url + "/overviewTables/agents", dto); },
        getGroupsTable: function (dto) { return http.post(url + "/overviewTables/groups", dto); },
        getCompletedChatsHistogram: function (dto) { return http.post(url + "/completedChats/histogram", dto); },
        getCompletedChatsCumulative: function (dto) { return http.post(url + "/completedChats/cumulative", dto); },
        getSatisfactionScoreHistogram: function (dto) {
            return http.post(url + "/satisfactionScore/histogram", dto);
        },
        getSatisfactionScoreCumulative: function (dto) {
            return http.post(url + "/satisfactionScore/cumulative", dto);
        },
    };
};
//# sourceMappingURL=index.js.map